import { DataType } from '@wix/editor-platform-ooi-metadata-resolver';
import {
  createSettingsParam,
  createSettingsParams,
  SettingsParamType,
} from '@wix/tpa-settings';
import { SLOTS } from '../../lib/slots';
import { getDefaultPaginationAlignment } from './utils';

export enum Alignment {
  Left = 'left',
  Center = 'center',
  Right = 'right',
}

export type ISettingsParams = {
  isSearchBarEnabled: SettingsParamType.Boolean;
  searchBarPlaceholder: SettingsParamType.Text;
  itemsPerPage: SettingsParamType.Number;
  isResultsMessageWithQuery: SettingsParamType.Boolean;
  isResultsMessageWithNumber: SettingsParamType.Boolean;
  isResultsEmptyMessageWithNumber: SettingsParamType.Boolean;
  isResultsEmptyMessageWithQuery: SettingsParamType.Boolean;
  resultsMenuAlignment: SettingsParamType.String;
  paginationAlignment: SettingsParamType.String;
  isProductsAddToCartEnabled: SettingsParamType.Boolean;
  productsAddToCartButtonText: SettingsParamType.String;
  isProductsFacetsEnabled: SettingsParamType.Boolean;
  isForumsFacetsEnabled: SettingsParamType.Boolean;
  'search-results-page-products-gallery': SettingsParamType.Object;
};

export default createSettingsParams<ISettingsParams>({
  isSearchBarEnabled: {
    key: 'isSearchBarEnabled',
    getDefaultValue() {
      return true;
    },
  },
  searchBarPlaceholder: {
    key: 'searchBarPlaceholder',
    getDefaultValue({ t }) {
      return t('settings.searchBar.placeholderInput.defaultValue');
    },
  },
  itemsPerPage: {
    key: 'itemsPerPage',
    getDefaultValue() {
      return 12;
    },
  },
  isResultsMessageWithQuery: {
    key: 'isResultsMessageWithQuery',
    getDefaultValue() {
      return true;
    },
  },
  isResultsMessageWithNumber: {
    key: 'isResultsMessageWithNumber',
    getDefaultValue() {
      return true;
    },
  },
  isResultsEmptyMessageWithNumber: {
    key: 'appLayout',
    getDefaultValue() {
      return false;
    },
  },
  isResultsEmptyMessageWithQuery: {
    key: 'isResultsEmptyMessageWithQuery',
    getDefaultValue() {
      return false;
    },
  },
  resultsMenuAlignment: {
    key: 'resultsMenuAlignment',
    getDefaultValue({ isRTL }) {
      return isRTL ? Alignment.Right : Alignment.Left;
    },
  },
  paginationAlignment: {
    key: 'paginationAlignment',
    getDefaultValue() {
      return getDefaultPaginationAlignment();
    },
  },
  isProductsAddToCartEnabled: {
    key: 'isProductsAddToCartEnabled',
    getDefaultValue() {
      return true;
    },
  },
  productsAddToCartButtonText: {
    key: 'productsAddToCartButtonText',
    getDefaultValue({ t }) {
      return t('settings.display.products.addToCart.buttonText');
    },
  },
  isProductsFacetsEnabled: {
    key: 'isProductsFacetsEnabled',
    getDefaultValue() {
      return true;
    },
  },
  isForumsFacetsEnabled: {
    key: 'isForumsFacetsEnabled',
    getDefaultValue() {
      return true;
    },
  },
  'search-results-page-products-gallery':
    createSettingsParam<SettingsParamType.Object>(SLOTS.products.id, {
      type: SettingsParamType.Object,
      getDefaultValue: () => ({}),
      metadata: {
        type: DataType.container,
        defaultValue: {
          type: 'static',
          value: {},
        },
        dataItemManifestData: {
          container: {
            containerType: 'slot',
            slot: {
              slotId: SLOTS.products.id,
            },
          },
        },
      },
    }),
});
